import type { ReactNode } from "react";
import { Skeleton } from "./Skeleton.tsx";
import styles from "./Page.module.css";

export function Page({ children }: { readonly children: ReactNode }) {
  return <div className={styles.column}>{children}</div>;
}

export function OpenPage({ busy = false, children }: { readonly busy?: boolean; readonly children: ReactNode }) {
  return (
    <div className={styles.open} data-column="larga" aria-busy={busy || undefined}>
      {children}
    </div>
  );
}

interface PageHeaderProps {
  readonly title: string;
  readonly intro?: string;
  readonly action?: ReactNode;
  readonly children?: ReactNode;
  readonly "data-morph"?: string;
}

export function PageTitle({ children }: { readonly children: ReactNode }) {
  return <h1 className={styles.title}>{children}</h1>;
}

export function PageHeader({ title, intro, action, children, ...morph }: PageHeaderProps) {
  return (
    <header className={styles.header} {...morph}>
      <div className={styles.titleRow}>
        <PageTitle>{title}</PageTitle>
        {action}
      </div>
      {intro === undefined ? null : <p>{intro}</p>}
      {children}
    </header>
  );
}

type Bar = { readonly height: string; readonly width?: string };

export function PageLoading({ header, bars }: { readonly header: ReactNode; readonly bars: readonly Bar[] }) {
  return (
    <>
      {header}
      <div className={styles.loading} aria-busy="true">{bars.map((bar, index) => <Skeleton key={index} {...bar} />)}</div>
    </>
  );
}

export function Empty({ children }: { readonly children: ReactNode }) {
  return <p className={styles.empty}>{children}</p>;
}
